import React, { useState } from 'react'
import { Col, message, Modal, Row } from 'antd'
import DropDown from '../inputs/DropDown'
import './CopyVersionModal.scss'

const CopyVersionModal = ({
  visible,
  onOk,
  onCancel,
  loading,
  copyFromOptions = []
}) => {
  const [copyFromVersion, setCopyFromVersion] = useState(null)
  return (
    <Modal
      title='COPY VERSION'
      visible={visible}
      onOk={() => {
        console.log('copyFromVersion', copyFromVersion)
        if (!copyFromVersion) {
          message.warning('Please select a version')
        } else {
          onOk({
            copyFromVersion,
            setCopyFromVersion
          })
        }
      }}
      onCancel={() => {
        onCancel()
        setCopyFromVersion(null)
      }}
      className='general-modal copy-version-modal'
      okButtonProps={{
        loading
      }}
      // width='1000px'
      okText='COPY'
    >
      <div className='copy-version-modal-wrapper'>
        <Row className='basic-date-picker' gutter={[24, 24]}>
          <Col span={24} className='input-field'>
            <label>Versions </label>
            <DropDown
              selectedValue={copyFromVersion}
              options={copyFromOptions}
              valueParam='id'
              displayParam='name'
              onOptionSelect={(value) => {
                setCopyFromVersion(value)
              }}
            />
            <h5>
              Select a version to copy assets from. This will override all assets in the current version.
            </h5>
          </Col>
        </Row>
      </div>

      {/* <Modal
        className='general-modal copy-version-modal'
        title='CONFIRM OVERRIDE'
        visible={isConfirmModalVisible}
        onOk={() => {
          console.log('copyFromVersion', copyFromVersion)
          if (!copyFromVersion) {
            message.warning('Please select a version')
          } else {
            onOk({
              copyFromVersion,
              setCopyFromVersion
            })
          }
        }}
        onCancel={() => {
          setConfirmModalVisible(false)
        }}
        okText='Yes'
        cancelText='Cancel'
      >
        Are you sure you want to override assets ?
      </Modal> */}
    </Modal>
  )
}

export default CopyVersionModal
